module.exports = __webpack_public_path__ + "media/packs/images/flags/SY-3c90009c509f1e141743d2368a8c6bfd.svg";